// Generated by scripts/update-seeq-icons.js from src/svg/seeq/samples-only.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSamplesOnly = {
  prefix: 'fak',
  iconName: 'samples-only' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f931',
    'M134.7 483.5c18.3 35.1 4.7 78.4-30.4 96.8s-78.4 4.7-96.7-30.4c-18.3-35.1-4.7-78.4 30.4-96.7s78.4-4.7 96.7 30.3zM575.1 484c18.3 35.1 4.7 78.4-30.3 96.8s-78.4 4.7-96.8-30.4c-18.3-35.1-4.7-78.4 30.4-96.7s78.4-4.7 96.7 30.3zM1015.5 484.6c18.3 35.1 4.7 78.4-30.3 96.7s-78.4 4.7-96.7-30.4c-18.3-35.1-4.7-78.4 30.3-96.7s78.4-4.7 96.7 30.4z',
  ],
} satisfies IconDefinition;
